// Third Party Library
import React, { useState } from "react";
import { Modal, Button, Select, Input, Col, DatePicker, Space } from "antd";
import { PlusOutlined, MinusOutlined } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router";

// Constant
import { COMMON_FEATURES, ROUTES } from "../../../constants";

// Components Library
import { ButtonLink } from "../../../components";

import { tableHDLR } from "../../../handlers";

import { TIME, REDUX as REDUX_UTIL } from "../../../services/util";

import * as REDUX_ACTION from "../../../services/redux/actions";

// Styles
import "./index.css";

const { RangePicker } = DatePicker;

const {
  todayStart,
  todayEnd,
  todayStartTime,
  todayEndTime,
  lastNDay,
  currentTimeMilliSecond,
} = TIME;
const { reduxStoreWrapper } = REDUX_UTIL;

const FilterData = (props) => {
  const {
    isModalOpen,
    setIsModalOpen,
    selectOptions,
    groupOptions,
    filteredData,
    setFilteredData,
    setIsFiltered,
    type,
  } = props;

  const dispatch = useDispatch();
  const location = useLocation();
  const { pathname = "" } = location;

  const userRole = useSelector(reduxStoreWrapper("user.uroleid"));

  const [filters, setFilters] = useState([
    { key: 1, type: "", value: "", label: "" },
  ]);
  const [nextKey, setNextKey] = useState(2);

  const options =
    userRole === "EMR"
      ? selectOptions.filter((g) => !g.label.includes("Company"))
      : selectOptions;

  const setToZero = (date) => {
    const normalizedDate = new Date(date);
    normalizedDate.setHours(0, 0, 0, 0); // Set time to 00:00:00
    return normalizedDate.getTime(); // Return epoch time in milliseconds
  };

  const nFirst = setToZero(lastNDay(90));
  const nLast = setToZero(currentTimeMilliSecond());

  const handleOptionChange = (key, value) => {
    const option = selectOptions.find((o) => o.value === value) || {};
    const { type } = option;

    const updatedFilters = filters.map((n) => {
      if (n.key === key) {
        if (value === "createdAt") {
          return {
            ...n,
            type: type,
            value: value,
            item: [todayStartTime, todayEndTime],
          };
        } else {
          return { ...n, type: type, value: value };
        }
      }
      return n;
    });

    setFilters(updatedFilters);
  };

  const handleValueChange = (key, value) => {
    const updatedFilters = filters.map((filter) =>
      filter.key === key ? { ...filter, item: value } : filter
    );
    setFilters(updatedFilters);
  };

  const handleAddFilter = () => {
    setFilters([...filters, { key: nextKey, type: "", value: "" }]);
    setNextKey(nextKey + 1);
  };

  const handleRemoveFilter = (key) => {
    const updatedFilters = filters.filter((filter) => filter.key !== key);

    setFilters(updatedFilters);
  };

  // const handleFilter = () => {
  //   let newData = filteredData; // Start with the default dataSource

  //   switch (searchType) {
  //     case "timeframe": {
  //       const [startDate, endDate] = f.item.map((date) => new Date(date));

  //       const start = setToZero(new Date(startDate));
  //       const end = setToZero(new Date(endDate));
  //       const isInRange = start >= nFirst && end <= nLast;

  //       if (!start || !end) {
  //         newData = filteredData;
  //         break;
  //       }

  //       if (!isInRange) {
  //         if (type) {
  //           switch (type) {
  //             case "payroll":
  //               dispatch(
  //                 REDUX_ACTION.v1_payroll.get_payroll_timeframe_all_request(
  //                   start,
  //                   end
  //                 )
  //               );
  //               break;
  //             case "billing":
  //               dispatch(
  //                 REDUX_ACTION.v1_billing.get_all_billing_request(start, end)
  //               );
  //               break;
  //           }
  //         } else {
  //           newData = filteredData.filter((item) => {
  //             const itemDate = setToZero(
  //               new Date(item[f.value]).getTime()
  //             );
  //             return itemDate >= start && itemDate <= end;
  //           });
  //         }
  //       } else {
  //         newData = filteredData.filter((item) => {
  //           const itemDate = setToZero(new Date(item[f.value]).getTime());
  //           return itemDate >= start && itemDate <= end;
  //         });
  //       }
  //       break;
  //     }
  //     case "text":
  //       newData = filteredData.filter((item) => {
  //         const searchValueLowerCase = f.item.toLowerCase();
  //         const itemValueLowerCase = item[f.value]?.toLowerCase() || "";
  //         return itemValueLowerCase.includes(searchValueLowerCase);
  //       });
  //       break;
  //     default:
  //       break;
  //   }
  //   setFilteredData(newData);
  // };

  const handleFilter = () => {
    let needsDispatch = false;
    let start, end;
  
    const filtered = filteredData.filter((item) => {
      return filters.every((f) => {
        if (f.type === "date") {
          const [startDate, endDate] = f.item.map((date) => date);
          start = setToZero(startDate);
          end = setToZero(endDate);
  
          if (!start || !end) {
            return false;
          }
  
          const isRange = start >= nFirst && end <= nLast;
          const itemDate = setToZero(new Date(item[f.value]));
  
          if (!isRange) {
            if (type) {
              needsDispatch = true;
            } else {
              return itemDate >= start && itemDate <= end;
            }
          } else {
            return itemDate >= start && itemDate <= end;
          }
        } else if (f.type === "text") {
          const searchValueLowerCase = f.item.toLowerCase();
          const itemValueLowerCase = item[f.value]?.toLowerCase() || "";
          return itemValueLowerCase.includes(searchValueLowerCase);
        }
        return true;
      });
    });
  
    setFilteredData(filtered);
  
    if (needsDispatch && start && end) {
      switch (type) {
        case "payroll":
          dispatch(REDUX_ACTION.v1_payroll.get_payroll_timeframe_all_request(start, end));
          break;
        case "billing":
          dispatch(REDUX_ACTION.v1_billing.get_all_billing_request(start, end));
          break;
        default:
          break;
      }
    }
  };
  

  const FilterInput = (filter) => {
    switch (filter.type) {
      case "date":
        return (
          <RangePicker
            style={{ width: "240px" }}
            onChange={(dates, dateStrings) =>
              handleValueChange(filter.key, dateStrings)
            }
            defaultValue={[todayStart, todayEnd]}
            format="YYYY-MM-DD"
          />
        );
      case "text":
        return (
          <Input
            style={{ width: "240px" }}
            value={filter.item}
            onChange={(e) => handleValueChange(filter.key, e.target.value)}
          />
        );
      case "select":
        return (
          <Select
            style={{ width: "240px" }}
            placeholder="Select a group"
            value={filter.item}
            onChange={(value) => handleValueChange(filter.key, value)}
            options={groupOptions}
          />
        );
      default:
        return (
          <Input
            style={{ width: "240px" }}
            value={filter.item}
            onChange={(e) => handleValueChange(filter.key, e.target.value)}
          />
        );
    }
  };

  const handleReset = () => {
    setFilters([{ key: 1, type: "", value: "", label: "" }]);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setFilters([{ key: 1, type: "", value: "", label: "" }]);
  };

  const handleApply = () => {
    handleFilter();
    handleCancel();
    userRole === "A" &&
      pathname === ROUTES.MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.EMPLOYEE] &&
      setIsFiltered(true);
  };

  return (
    <>
      <Modal
        centered
        open={isModalOpen}
        width={650}
        footer={null}
        closeIcon={null}
        maskClosable={true}
        onCancel={handleCancel}
      >
        <div className="header">
          <span className="filterText">Filter</span>
          <div className="headerBtn">
            <Button key="cancel" onClick={handleReset} className="resetBtn">
              Reset
            </Button>
            <Button
              key="apply"
              type="primary"
              style={{ marginLeft: "8px" }}
              onClick={handleApply}
            >
              Apply
            </Button>
          </div>
        </div>
        {filters.map((filter, index) => {
          return (
            <Space wrap key={filter.key} style={{ margin: "10px 0" }}>
              <Select
                style={{ width: "180px" }}
                placeholder="- Select -"
                value={filter.value}
                onChange={(value) => handleOptionChange(filter.key, value)}
                options={options.map((option) => ({
                  ...option,
                  disabled: filters.some(
                    (f) => f.value === option.value && f.key !== filter.key
                  ),
                }))}
              />
              <Input
                style={{ width: "110px", color: "black" }}
                value={
                  filter.type
                    ? filter.type === "date"
                      ? "Range"
                      : "Contains"
                    : ""
                }
                disabled
              />
              {FilterInput(filter)}
              {index > 0 && (
                <Col span={1}>
                  <MinusOutlined
                    onClick={() => handleRemoveFilter(filter.key)}
                  />
                </Col>
              )}
            </Space>
          );
        })}
        {filters.length === selectOptions.length ? (
          <></>
        ) : (
          <ButtonLink
            onClick={handleAddFilter}
            style={{ color: "#506DEE", textAlign: "left" }}
          >
            <PlusOutlined />
            <span style={{ marginLeft: "5px", fontWeight: "600" }}>
              Add new filter
            </span>
          </ButtonLink>
        )}
      </Modal>
    </>
  );
};

export default FilterData;
